module.exports = __webpack_public_path__ + "img/vertical_6_2_5012.7ced58cc.png";